<div class="row" style="margin-top:1rem;">
  <div *ngIf="annonces.length > 0" [class]="isMobile ? 'col-12' : 'col-3'">
    <app-topannonce-bis [annonces]="annonces" [charger]="charger"></app-topannonce-bis>
  </div>
  <div [class]="isMobile || annonces.length <= 0 ? 'col-12' : 'col-9'">
    <div class="row" style="height: auto">

    </div>
    <div *ngIf="config('home1')?._view" class="row">
      <div class="col-md-12">
        <div  [class]="config('title_home1')?.param2 ? 'card ' + config('title_home1')?.param2 : 'card'">
          <div *ngIf="config('title_home1')?._view" [style]="safeCss(config('cards_colors')?.style)" id="title"  [class]="config('title_home1')?.class ? 'card-header ' + config('title_home1')?.class : 'card-header'">

            <h2 [class]="config('title_home1')?.param1 ? 'card-title ' + config('title_home1')?.param1 : ''">
              {{ config('title_home1')?.txt }}
            </h2>
          </div>
          <div class="card-body">
            <section class="row d-flex flex-row tm-pt-4 tm-pb-6">
              <div class="col-12 align-self-center my-auto align-items-center tm-page-cols-container" style="text-align:justify">
                <div class="">
                  <p>
                    Nous proposons des contrats à durée déterminée saisonniers, à temps complet (35 heures hebdomadaires). Ces contrats s'adressent à des candidats débutants ou diplômés pour les Sauveteurs, candidats français ou étrangers (disposant d'un titre de séjour autorisant l'emploi salarié en France) dès lors qu'ils ont 18 ans minimum. Les horaires sont flexibles en raison de notre type d'activité mais le rythme normal est de 5 jours de travail par semaine (avec 2 jours de repos).
                    Si vous êtes intéressé(e), merci de choisir l’une des options suivantes :
                  </p>
                  <ul>
                    <li>SURVEILLANTS DE BAIGNADE (Brevet B.N.S.S.A. ou brevet B.P.J.E.P.S. spécialisation Activités Aquatiques et de la Natation) <b>DIPLOMES OBLIGATOIRES A JOUR et Recyclage PSE1 à jour si nécessaire.</b></li>
                    <li>EMPLOYES POLYVALENTS AQUASPLASH (accueil des visiteurs, gestion des consignes et des vestiaires, régulation des départs pour les attractions aquatiques…)
                    </li>
                    
                    <li>EMPLOYES POLYVALENTS RESTAURATION (accueil, encaissement, préparation, vente de produits à emporter et nettoyage salle et terrasses…)</li>

                  </ul>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>

    <div [matchHeight]="'card-title'" [charger]="charger" class="row d-flex justify-content-around">
      <div *ngFor="let item of baseCards; let index = index" class="col-lg-3 col-md-6 col-sm-6 ng-star-inserted">
        <div class="card card-stats" hover-class="card-grey">
          <div class="card-header card-header-rose card-header-icon">
            <div [style]="safeCss(config('cards_colors')?.style)" class="card-icon">
              <img *ngIf="item.img" width="48px" [src]="item.icon" />
              <i *ngIf="!item.img" class="material-icons">{{item.icon}}</i>
            </div>
            <p class="card-category">{{ item.title }}</p>
            <h3 class="card-title">{{ actualCards[index] }}</h3>
          </div>
          <div class="card-footer">
            <div class="stats"></div>
          </div>
        </div>
      </div>
    </div>

    <div [matchHeight]="'card-body'" [charger]="charger" class="row">
      <div *ngIf="config('home2')?._view" class="col-md-6">
        <div [class]="config('title_home2')?.class ? 'card ' + config('title_home2')?.class : 'card'">
          <div *ngIf="config('title_home2')?.param4 === '0'" [style]="safeCss(config('cards_colors')?.style)" class="card-header card-header-grey">
            <h2 class="card-title text-center" style="color: white; font-family: 'Bjorn Regular', sans-serif; ">{{ config('title_home2')?.txt }}</h2>
          </div>
          <div *ngIf="config('title_home2')?.param4 === '1'" class="card-header card-header-image">
            <img src="https://fichiers.rhprofiler.fr/marineland/images/front/aqua1.jpg">
          </div>
          <div class="card-body">
            <!--<h4 *ngIf="config('title_home2')?.param4 === '1'" [class]="config('title_home2')?.param1">
              <b>{{ config('title_home2')?.txt }}</b>
            </h4>-->
            <div class="card-content" style="text-align:justify">
              Chaque année, Aquasplash propose des jobs d'été en juillet et en août aux étudiants qui veulent se consacrer entièrement à leurs études pendant l'année scolaire.
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="config('home3')?._view" class="col-md-6">
        <div [class]="config('title_home3')?.class ? 'card ' + config('title_home3')?.class : 'card'">
          <div *ngIf="config('title_home3')?.param4 === '0'" [style]="safeCss(config('cards_colors')?.style)" class="card-header card-header-grey">
            <h2 class="card-title text-center" style="color: white; font-family: 'Bjorn Regular', sans-serif; ">{{ config('title_home3')?.txt }}</h2>
          </div>
          <div *ngIf="config('title_home3')?.param4 === '1'" class="card-header card-header-image">
            <img src="https://fichiers.rhprofiler.fr/marineland/images/front/aqua2.jpg">
          </div>
          <div class="card-body">
            <!--<h4 *ngIf="config('title_home3')?.param4 === '1'" [class]="config('title_home3')?.param1">
              <b>{{ config('title_home3')?.txt }}</b>
            </h4>-->
            <div class="card-content" style="text-align:justify">
              Nous proposons des contrats à durée déterminée à caractère saisonnier à temps complet (35 heures hebdomadaires). Ces contrats s'adressent à des candidats débutants ou expérimentés, des étudiants français ou étrangers (disposant d'un titre de séjour autorisant l'emploi salarié en France) dès lors qu'ils ont 18 ans minimum.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
